import React from 'react';
import 'material-symbols/outlined.css';

interface IconProps {
  name: string;
  size?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  filled?: boolean;
}

const Icon: React.FC<IconProps> = ({ name, size = 24, color, className = '', style, filled = false }) => (
  <span
    className={`material-symbols-outlined ${className}`.trim()}
    style={{
      fontSize: size,
      color,
      fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' 100, 'GRAD' 0, 'opsz' 24`,
      lineHeight: 1,
      verticalAlign: 'middle',
      ...style,
    }}
  >
    {name}
  </span>
);

export default Icon;
